<template>
    <div>
        <!-- Modal Alterar Data -->
        <div class="modal fade" id="alterarDataModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Alterar Data</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="marcacao">
                        <div class="alert alert-info">
                            <div class="lead">{{ marcacao.nome_paciente }}</div>
                            <div>#{{ marcacao.id_atendimento }}</div>
                        </div>

                        <az-input 
                            label="Data" 
                            type="datetime-local" 
                            placeholder="Nova Data..." 
                            required
                            :validate="validate"
                            v-model="nova_data" />

                        <pre v-if="false">{{ marcacao }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            marcacao: null, 
            nova_data: '', 
            validate: false, 
        }
    },

    components: {
        AzInput, 
        AzSubmit
    },

    methods: { 
        abrir(marcacao) { 
            this.nova_data = marcacao.dt_inicio;
            this.marcacao = _.cloneDeep(marcacao);  

            $('#alterarDataModal').modal('show');
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'atendimentos',
                func: 'alterar_data', 
                dados: { 
                    id_atendimento: this.marcacao.id_atendimento, 
                    nova_data: this.nova_data 
                },
                modal: 'alterarDataModal',
                callback: () => { 
                    this.$emit('refresh')
                }
            });
        }
    }
}
</script>
